import { render } from "./TheCat.vue?vue&type=template&id=5aef678a&scoped=true&ts=true"
import script from "./TheCat.vue?vue&type=script&lang=ts"
export * from "./TheCat.vue?vue&type=script&lang=ts"

import "./TheCat.vue?vue&type=style&index=0&id=5aef678a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\joaog\\Documents\\GitHub\\friendly-fox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aef678a"]])

export default __exports__